import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=b70d1ed4&scoped=true"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=b70d1ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d1ed4",
  null
  
)

export default component.exports